import type { NotificationBadgeVariant } from '@components/atoms/notification-badge';
import { FloatingPanelToneEnum } from './types';

export const TONE_ICON_CONTAINER_CLASS: Record<FloatingPanelToneEnum, string> = {
	[FloatingPanelToneEnum.SUCCESS]: 'bg-success/10',
	[FloatingPanelToneEnum.WARNING]: 'bg-warning/10',
	[FloatingPanelToneEnum.ERROR]: 'bg-error/10',
	[FloatingPanelToneEnum.LOADING]: 'bg-bgPrimary',
};

export const TONE_ICON_CLASS: Record<FloatingPanelToneEnum, string> = {
	[FloatingPanelToneEnum.SUCCESS]: 'text-success',
	[FloatingPanelToneEnum.WARNING]: 'text-warning',
	[FloatingPanelToneEnum.ERROR]: 'text-error',
	[FloatingPanelToneEnum.LOADING]: 'text-secondary',
};

export const TONE_DOT_CLASS: Record<FloatingPanelToneEnum, string> = {
	[FloatingPanelToneEnum.SUCCESS]: 'bg-success',
	[FloatingPanelToneEnum.WARNING]: 'bg-warning',
	[FloatingPanelToneEnum.ERROR]: 'bg-error',
	[FloatingPanelToneEnum.LOADING]: 'bg-secondary',
};

export function toBadgeVariant(tone: FloatingPanelToneEnum): NotificationBadgeVariant {
	switch (tone) {
		case FloatingPanelToneEnum.SUCCESS:
			return 'success';
		case FloatingPanelToneEnum.WARNING:
			return 'warning';
		case FloatingPanelToneEnum.ERROR:
			return 'error';
		case FloatingPanelToneEnum.LOADING:
			return 'neutral';
		default: {
			const _exhaustive: never = tone;
			return _exhaustive;
		}
	}
}
